(function () {
    var s = (typeof (Vendd) != "undefined" && Vendd.Scripts) || (typeof (Scripts) != "undefined" && Scripts);
    if (!s) return;
    s.load(function () {
        'use strict';
        var TrackingScriptName = 'ContactPigeon';

        var TrackingModel = LhApp.Function.Tracking.getTrackingModel();
        var Tracker = LhApp.Function.Tracking.getTracker("contactpigeon", TrackingModel);

        if (!Tracker || !Tracker.Properties.ContactPigeonAccount || !Tracker.Properties.ContactPigeonUrl || !Tracker.Properties.ContactPigeonUrl.startsWith('//'))
            return;

        var CanTrack = LhApp.Function.Tracking.canTrack();

        function Track() {
            var el = document.createElement('script');
            el.async = 1;
            el.src = Tracker.Properties.ContactPigeonUrl;
            var scr = document.getElementsByTagName('script')[0];
            scr.parentNode.insertBefore(el, scr);
        }

        Init();

        function Init() {
            if (!CanTrack) return;

            window.cpaAccount = Tracker.Properties.ContactPigeonAccount;
            window.cpa_async = { 'ctag': '', 'utmipn': '', 'utmipc': '', 'utmtid': '', 'utmtto': '', 'cutmcn': '', 'cutmcc': '' };
            window.cpaE = '';
            if (Tracker.Properties.ContactPigeonConfig)
                window.cpanots_config = Tracker.Properties.ContactPigeonConfig;

            //TRACK order completion
            if (TrackingModel.IsThankYouPage && TrackingModel.CartProductsData && TrackingModel.Order) {
                if (TrackingModel.Order.IsAlreadyTracked)
                    return;

                if (typeof angular !== 'undefined') {
                    angular.element(document).ready(function () {
                        var oScope = angular.element('.x-control.x-angular-control.x-checkoutorder').scope();
                        var tracked = false;
                        if (oScope && !tracked) {
                            if (TrackingModel.IsThankYouPage) //cookie consent had been granted
                            {
                                tracked = true;

                                var checkoutEmail = oScope.Model.Data.Profile.Email.trim().toLowerCase();

                                window.cpaE = checkoutEmail;
                                Track();
                            }
                        }
                    });
                }
            }        
            else if (TrackingModel.IsCheckoutPage && TrackingModel.CartProductsData && typeof angular !== 'undefined') {
                angular.element(document).ready(function () {
                    var orderAngularElement = angular.element('.x-control.x-angular-control.x-checkoutorder');
                    if (orderAngularElement) {
                        var orderScope = orderAngularElement.scope();
                        var checkoutEmail = orderScope.Model.Data.Profile
                            && orderScope.Model.Data.Profile.Email
                            && orderScope.Model.Data.Profile.Email.trim().toLowerCase()
                            || '';

                        window.cpaE = checkoutEmail;
                        Track();
                    }
                });
            }
        }

        if (typeof (Vendd) != "undefined" && Vendd.Scripts) {

            Vendd.MessageBus.subscribe(Vendd.User.Messages.GetUserViewModelSuccess, TrackingScriptName, function (envelope) {
                if (!CanTrack) return;

                if (envelope && envelope.message && envelope.message.data && envelope.message.data.model) {
                    if (envelope.message.data.model.IsAuthenticated && envelope.message.data.model.Email) {
                        window.cpaE = envelope.message.data.model.Email;
                    }
                    Track();
                }
            });
        }
    });
})();
